import { render, staticRenderFns } from "./base-sidebar-item.vue?vue&type=template&id=90af0558&scoped=true&"
import script from "./base-sidebar-item.vue?vue&type=script&lang=ts&"
export * from "./base-sidebar-item.vue?vue&type=script&lang=ts&"
import style0 from "./base-sidebar-item.vue?vue&type=style&index=0&id=90af0558&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90af0558",
  null
  
)

export default component.exports